
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PaymentLinkProps {
  paymentLinkUrl: string;
}

export const PaymentLink = ({ paymentLinkUrl }: PaymentLinkProps) => {
  return (
    <div className="pt-4 space-y-2">
      <Button
        className="w-full"
        asChild
      >
        <a 
          href={paymentLinkUrl}
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2"
        >
          <ExternalLink className="w-4 h-4" />
          Pagar aquí
        </a>
      </Button>
      <p className="text-sm text-muted-foreground italic text-center">
        Nota: Este pago solo quedará como "Pagado" una vez que se suba el PDF o imagen comprobante de pago.
      </p>
    </div>
  );
};
